module.exports = __webpack_public_path__ + "static/media/gallery_bx_6th_16_9_AR.5cb3fe23.jpg";